export default function VideoHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-50 via-white to-amber-50">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <div className="mb-6">
            <span className="text-xs uppercase tracking-wider text-teal-600 font-medium">• AUTHOR VIDEOS</span>
          </div>
          
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Watch & Listen
          </h1>
          
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8">
            Explore video content featuring Melinda Holcomb sharing her journey, insights on healing, faith, and resilience. Watch interviews, readings, and personal reflections.
          </p>

          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-gray-600">
              <i className="ri-play-circle-line text-2xl text-teal-600"></i>
              <span className="text-sm font-medium">Video Collection</span>
            </div>
            <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
            <div className="flex items-center gap-2 text-gray-600">
              <i className="ri-time-line text-xl text-teal-600"></i>
              <span className="text-sm font-medium">Inspiring Stories</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
